<template>
  <div>
    <background-detail showpages="liftManagementInfo"></background-detail>
  </div>
</template>

<script>
/**
 *@ClassName:liftManagementInfo
 *@Description:电梯详情
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-04-27
 */
  import backgroundDetail from '../../../components/backgroundDetail.vue' 
   export default {
   components: {
      'background-detail': backgroundDetail 
    },
    data () {
      return {}
    },
    computed: {},
    watch: {},
    methods: {
    
  },
}
</script>
<style lang='scss'>
 
</style>
